var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLocation(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 28,
    viewBox: "0 0 22 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1.75 11.2632C1.75 7.72524 3.1487 5.3735 4.97294 3.8913C6.8232 2.38796 9.15036 1.75 11 1.75C12.8915 1.75 15.2126 2.23842 17.0425 3.64695C18.8383 5.0292 20.25 7.36446 20.25 11.2632C20.25 14.1289 18.8732 17.0864 17.0004 19.7221C15.1365 22.3453 12.842 24.5643 11.1472 25.9335C11.0727 25.9937 10.9688 25.993 10.8937 25.9276C9.193 24.4477 6.88665 22.1037 5.01228 19.4434C3.12324 16.7622 1.75 13.8675 1.75 11.2632ZM11 0.25C8.84964 0.25 6.1768 0.980457 4.02706 2.72713C1.8513 4.49493 0.25 7.27476 0.25 11.2632C0.25 14.3378 1.84209 17.5482 3.78607 20.3073C5.74473 23.0873 8.13908 25.519 9.90908 27.0592C10.5301 27.5996 11.4464 27.6201 12.0898 27.1003C13.8684 25.6635 16.2646 23.3474 18.2232 20.591C20.1728 17.8472 21.75 14.5809 21.75 11.2632C21.75 6.95133 20.1617 4.15501 17.9575 2.45831C15.7874 0.7879 13.1085 0.25 11 0.25ZM14.5 11C14.5 12.933 12.933 14.5 11 14.5C9.067 14.5 7.5 12.933 7.5 11C7.5 9.067 9.067 7.5 11 7.5C12.933 7.5 14.5 9.067 14.5 11ZM16 11C16 13.7614 13.7614 16 11 16C8.23858 16 6 13.7614 6 11C6 8.23858 8.23858 6 11 6C13.7614 6 16 8.23858 16 11Z",
    fill: "#0A7CC1"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLocation);
export default __webpack_public_path__ + "static/media/location.c43a67e3464779ba3a9aa4363529a6cb.svg";
export { ForwardRef as ReactComponent };